'use client';

import React, { useState } from 'react';
import { Container } from '../Container';
import { Typography } from '../Typography';
import { HealthArticleType } from '../../constants';
import adviceIcon from './assets/icon-advice.svg';
import questionIcon from './assets/icon-question.svg';
import costIcon from './assets/icon-cost.svg';
import diagnosisIcon from './assets/icon-diagnosis.svg';
import recoveryIcon from './assets/icon-recovery.svg';
import treatmentIcon from './assets/icon-treatment.svg';
import whatToDoIcon from './assets/icon-what-to-do.svg';
import { HealthArticleBannerButton } from './HealthArticleBannerButton';
import { Button } from '../../wag-react/next-components/button';
import { Box } from '../../wag-react/next-components/box';
const items = {
  [HealthArticleType.Condition]: [{
    title: 'Symptoms',
    iconSrc: questionIcon,
    id: 'symptoms'
  }, {
    title: 'Causes',
    iconSrc: whatToDoIcon,
    id: 'causes'
  }, {
    title: 'Diagnosis',
    iconSrc: diagnosisIcon,
    id: 'diagnosis'
  }, {
    title: 'Treatment',
    iconSrc: treatmentIcon,
    id: 'treatment'
  }, {
    title: 'Recovery',
    iconSrc: recoveryIcon,
    id: 'recovery'
  }, {
    title: 'Community',
    iconSrc: adviceIcon,
    id: 'advice'
  }],
  [HealthArticleType.Symptom]: [{
    title: 'Overview',
    iconSrc: diagnosisIcon,
    id: 'overview'
  }, {
    title: 'Causes',
    iconSrc: questionIcon,
    id: 'why-it-occurs'
  }, {
    title: 'Treatment',
    iconSrc: treatmentIcon,
    id: 'what-to-do'
  }, {
    title: 'Prevention',
    iconSrc: whatToDoIcon,
    id: 'prevention'
  }, {
    title: 'Cost',
    iconSrc: costIcon,
    id: 'cost'
  }, {
    title: 'Community',
    iconSrc: adviceIcon,
    id: 'advice'
  }],
  [HealthArticleType.Treatment]: [{
    title: 'Procedure',
    iconSrc: diagnosisIcon,
    id: 'procedure'
  }, {
    title: 'Results',
    iconSrc: questionIcon,
    id: 'efficacy'
  }, {
    title: 'Recovery',
    iconSrc: recoveryIcon,
    id: 'recovery'
  }, {
    title: 'Cost',
    iconSrc: costIcon,
    id: 'cost'
  }, {
    title: 'Prevention',
    iconSrc: treatmentIcon,
    id: 'prevention'
  }, {
    title: 'Community',
    iconSrc: adviceIcon,
    id: 'advice'
  }]
};
export type HealthArticleBannerItem = Record<'title' | 'iconSrc' | 'id', string>;
export type HealthArticleBannerValue = Partial<HealthArticleBannerItem[]>;
type Props = {
  articleType: string; // 'Condition', 'Symptom' or 'Treatment'
};
export const HealthArticleBanner = ({
  articleType
}: Props) => {
  const [mobileLinksOpen, setMobileLinksOpen] = useState(false);
  return <>
      <Container display={['block', 'block', 'none']} border="1px solid #D8D8D9" borderRadius="100px" mb={mobileLinksOpen ? '14px' : '0'} data-sentry-element="Container" data-sentry-source-file="index.tsx">
        <Button width="100%" onClick={() => setMobileLinksOpen(old => !old)} data-sentry-element="Button" data-sentry-source-file="index.tsx">
          <Typography fontSize="16px" fontWeight="bold" my="16px" textAlign="center" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
            Quick jump to section
          </Typography>
        </Button>

      </Container>
      <Box as="ul" p={0} m={0} display={[mobileLinksOpen ? 'block' : 'none', null, 'flex']} style={{
      listStyleType: 'none'
    }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        {items[articleType].map((item, index) => <li key={`banner-item-${item.id || index}`}>
            <HealthArticleBannerButton {...item} mr={index < items[articleType].length - 1 ? ['0', '0px', '14px'] : ['0']} mb={index < items[articleType].length - 1 ? ['14px', '14px', '0px'] : ['0']} />
          </li>)}
      </Box>
    </>;
};
export type HealthArticleBannerProps = Props;